import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./Button.css');

// Enumerables
export enum EButtonType {
    Action,
    Important,
}

// Props
interface IButtonProps {
    onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null
    className?: string | null
    inBox?: boolean
    isDisabled?: boolean
    type?: EButtonType;
    icon?: {
        element: JSX.Element | null
        onLeft?: boolean
    } | null
}

// Default props
const defaultProps: IButtonProps = {
    onClick: null,
    className: null,
    inBox: false,
    isDisabled: false,
    type: EButtonType.Action,
    icon: {
        element: null,
        onLeft: false,
    },
};

// Component
@observer
export class Button extends React.Component<IButtonProps, {}> {
    public static defaultProps = defaultProps;

    constructor(props: IButtonProps) {
        super(props);
    }

    public render() {
        // Destructure
        const { className, type, inBox, isDisabled } = this.props;

        // Render
        return (
            <button
                disabled={isDisabled}
                onClick={this.handleButtonClick}
                className={classNames({
                    button: true,
                    [s.button]: true,
                    [s.box]: inBox,
                    [s.action]: type === EButtonType.Action,
                    [s.important]: type === EButtonType.Important,
                    [className]: !!className,
                })}
            >
                {(this.props.icon.element && this.props.icon.onLeft === true) && (
                    <span className={s.icon}>
                        {this.props.icon.element}
                    </span>
                )}

                <span className={s.children}>
                    {this.props.children}
                </span>

                {(this.props.icon.element && this.props.icon.onLeft === false) && (
                    <span className={s.icon}>
                        {this.props.icon.element}
                    </span>
                )}
            </button>
        );
    }

    private handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/Button.tsx